import { DetailsPageUploader } from '__generated__/DetailsPageUploader';
import { StructuredBriefFile } from '__generated__/StructuredBriefFile';
import AttachmentUploader from 'common/components/uploader/AttachmentUploader';
import { ObservableField as Field, ObservableForm } from 'projects/components/ObservableForm';
import React from 'react';

interface Fields {
    referenceFiles: StructuredBriefFile[];
}

interface Props<T> {
    form: ObservableForm<T>;
    uploader: DetailsPageUploader;
    required?: boolean;
}

const ReferenceFilesField: <T extends Fields>(props: Props<T>) => React.ReactElement<Props<T>> = ({
    form,
    uploader,
    required = false,
}) => {
    return (
        <Field
            form={form}
            name="referenceFiles"
            title={__('Add reference files')}
            required={required}
            message={__(
                'Upload any files that your designer needs including your logo, photos, brand guide, fonts, copy, and any other documents.'
            )}
            render={() => (
                <AttachmentUploader uploader={uploader} {...form.attach('referenceFiles')} />
            )}
        />
    );
};

export default ReferenceFilesField;
